// extracted by mini-css-extract-plugin
export default {"root":"root___CEbqO","my_ip":"my_ip___GQs9P","ip_bg":"ip_bg___MPNfV","download_hola":"download_hola___xUQ9z","download_btn":"download_btn___OEzfO","what_btn":"what_btn___iQAQZ"};